import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const ease = [0.22, 1, 0.36, 1];

/*
 * The reveal is orchestrated from the track, not from each card. Per-card
 * whileInView would leave every off-screen card at opacity 0, because an
 * IntersectionObserver clips its target against the rail's own overflow box.
 * Cards animate together when the rail scrolls into vertical view instead.
 */
export const railVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05 } },
};

export const railCardVariants = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease } },
};

const arrowClass =
  'w-11 h-11 rounded-full border border-[#ba1609]/30 text-[#ba1609] flex items-center justify-center hover:bg-[#ba1609] hover:text-white transition-colors duration-300';

const CardRail = ({ label, children }) => {
  const trackRef = useRef(null);

  // Advance by one card so the rail always lands on a snap point.
  const scrollByCards = (direction) => {
    const track = trackRef.current;
    const card = track && track.firstElementChild;
    if (!card) return;

    const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
  };

  return (
    <>
      <div className="flex justify-end gap-3 mb-6">
        <button
          type="button"
          onClick={() => scrollByCards(-1)}
          aria-label={`Previous ${label}`}
          className={arrowClass}
        >
          <FiChevronLeft className="w-5 h-5" />
        </button>
        <button
          type="button"
          onClick={() => scrollByCards(1)}
          aria-label={`Next ${label}`}
          className={arrowClass}
        >
          <FiChevronRight className="w-5 h-5" />
        </button>
      </div>

      <motion.div
        ref={trackRef}
        className="snap-rail hide-scrollbar -mx-4 pb-4 mb-12"
        variants={railVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default CardRail;
